// Simple bilingual service
import { Injectable, signal } from '@angular/core';

type Dict = Record<string,string>;

const EN: Dict = {
  'menu.plans': 'Plans',
  'menu.register': 'Register',
  'landing.headline': 'Reconcile faster — relax later',
  'landing.sub': 'Automate your account reconciliation with confidence.',
  'landing.cta_primary': 'Start free',
  'landing.cta_plans': 'View plans',
  'plans.title': 'How you can pay',
  'plans.pageTitle': 'Pricing & Plans',
  'plans.view': 'See details',
  'plans.choose': 'Choose plan',
  'register.title': 'Create your account',
  'register.email': 'Email',
  'register.firstName': 'First name',
  'register.lastName': 'Last name',
  'register.phone': 'Mobile phone',
  'register.submit': 'Sign up',
  'register.success': 'Registration successful!',
  'register.error': 'Registration failed. Try again.',
  'footer.rights': 'All rights reserved'
};

const BG: Dict = {
  'menu.plans': 'Планове',
  'menu.register': 'Регистрация',
  'landing.headline': 'Съгласувай по-бързо — отпусни се после',
  'landing.sub': 'Автоматизирай своите счетоводни съгласувания с увереност.',
  'landing.cta_primary': 'Започни безплатно',
  'landing.cta_plans': 'Виж плановете',
  'plans.title': 'Как можеш да плащаш',
  'plans.pageTitle': 'Цени и планове',
  'plans.view': 'Виж подробности',
  'plans.choose': 'Избери план',
  'register.title': 'Създай акаунт',
  'register.email': 'Имейл',
  'register.firstName': 'Име',
  'register.lastName': 'Фамилия',
  'register.phone': 'Мобилен номер',
  'register.submit': 'Регистрирай се',
  'register.success': 'Успешна регистрация!',
  'register.error': 'Грешка при регистрация. Опитайте пак.',
  'footer.rights': 'Всички права запазени'
};

@Injectable({ providedIn: 'root' })
export class TranslateService {
  // current language signal (reactive)
  private _lang = signal<'en'|'bg'>('en');
  dicts = { en: EN, bg: BG };

  get current() { return this._lang(); }
  set current(v: 'en'|'bg') { this._lang.set(v); }

  translate(key: string): string {
    const d = this.dicts[this.current] || EN;
    return d[key] ?? key;
  }
}
